import {AbstractControl, ValidatorFn} from "@angular/forms";

export function urlValidator(): ValidatorFn {
	return (control: AbstractControl): { [key: string]: any } | null => {
		const urlPattern = /^(https?:\/\/)?([a-z0-9-]+\.)+[a-z]{2,}(:\d+)?(\/[^\s]*)?$/i;
		if (control.value) {
			const valid = urlPattern.test(control.value);
			return valid ? null : { "invalidUrl": { value: control.value } };
		}
		return null;
	};
}